import React from "react";
import PropTypes from "prop-types";

import "../../../packs/translations";

I18n.locale = $("html").attr("lang");

const NearestTerm = props => {
  return (
    <div className="calculation-list__item row d-flex">
      <div className="content col-md-6 col-lg-6">
        <div className="row">
          <span className="date">{props.dateLabel}</span>
        </div>
        <div className="row">
          <span
            className="place"
            dangerouslySetInnerHTML={{ __html: props.routes }}
          ></span>
          <span
            className="food"
            dangerouslySetInnerHTML={{ __html: props.meals }}
          ></span>
        </div>
      </div>
      <div className="price col-md-3 col-lg-3">{props.price}</div>
      <div className="select col-md-3 col-lg-3">
        <a
          href={props.hotelPath}
          className="btn btn-grey loader_on_click btn-block btn-sm"
          rel="nofollow"
        >
          {I18n.t("js.show_tour.show_select")}
        </a>
        <a
          href={props.orderTermPath}
          className="btn btn-tertiary btn-block btn-sm"
          rel="nofollow"
        >
          {I18n.t("js.show_tour.show_order")}
        </a>
      </div>
    </div>
  );
};

NearestTerm.propTypes = {
  id: PropTypes.number.isRequired,
  hotelPath: PropTypes.string.isRequired,
  orderTermPath: PropTypes.string.isRequired,
  price: PropTypes.any.isRequired,
  dateLabel: PropTypes.string.isRequired,
  routes: PropTypes.any.isRequired,
  meals: PropTypes.any.isRequired
};

export default NearestTerm;
